import styled from "styled-components";

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  margin: .5rem 4rem;
`;
